<template>
    <div>
        <b-list-group flush>
            <b-list-group-item>
                <div class="question" v-if="showComponent">

                    <div v-if="question.type == 'fill_in_the_blank' || question.type == 'new_fill_in_the_blank'">
                        <fill-in-the-blank :question="question" />
                    </div>

                    <div v-if="question.type == 'hot_text'">
                        <hot-text :question="question" />
                    </div>

                    <div v-if="question.type == 'labeling'">
                        <Labeling :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'drawing'">
                        <Drawing :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'hot_spot'">
                        <hot-spot :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'multiple_choice' || question.type == 'new_multiple_choice' || question.type == 'article_assessment'">
                        <multiple-choice :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'matching'">
                        <Matching :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'open_response'">
                        <open-response :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'text_block'">
                        <text-block :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'media_block'">
                        <media-block :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'select_all_that_apply' || question.type == 'new_select_all_that_apply'">
                        <select-all-that-apply :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'sorting'">
                        <Sorting :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'think_and_review'">
                        <!-- <think-and-review :question="question" /> -->
                    </div>

                    <div v-if="question.type == 'true_false'">
                        <true-false :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'numeric_response'">
                        <numeric-response :question="question" :question_html="question_html" />
                    </div>

                    <div v-if="question.type == 'grouping'">
                        <grouping :question="question" :question_html="question_html" />
                    </div>
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import FillInTheBlank from '@/components/questions/FillInTheBlank'
import HotText from '@/components/questions/HotText'
import Labeling from '@/components/questions/Labeling'
import HotSpot from '@/components/questions/HotSpot'
import Matching from '@/components/questions/Matching'
import MultipleChoice from '@/components/questions/MultipleChoice'
import TextBlock from '@/components/questions/TextBlock'
import MediaBlock from '@/components/questions/MediaBlock'
import OpenResponse from '@/components/questions/OpenResponse'
import SelectAllThatApply from '@/components/questions/SelectAllThatApply'
import Sorting from '@/components/questions/Sorting'
import TrueFalse from '@/components/questions/TrueFalse'
import NumericResponse from '@/components/questions/NumericResponse'
import Grouping from '@/components/questions/Grouping'
import Drawing from '@/components/questions/Drawing'

export default {
    data: () => ({
        showComponent: true
    }),
    props: [
        'question'
    ],
    components: {
        FillInTheBlank,
        HotText,
        Labeling,
        HotSpot,
        Matching,
        MultipleChoice,
        OpenResponse,
        SelectAllThatApply,
        Sorting,
        TextBlock,
        MediaBlock,
        TrueFalse,
        NumericResponse,
        Grouping,
        Drawing
    },
    computed: {
        question_html () {
            let question_html = null

            if (
                this.question &&
                this.question.content &&
                this.question.content.question
            ) {
                question_html = this.question.content.question
                question_html = question_html.replaceAll('<merlin-img', '<img')
                question_html = question_html.replaceAll('</merlin-img', '</img')
            } else if (
                this.question &&
                this.question.content &&
                this.question.content.question_prompt
            ) {
                question_html = this.question.content.question_prompt
                question_html = question_html.replaceAll('<merlin-img', '<img')
                question_html = question_html.replaceAll('</merlin-img', '</img')
            }

            return question_html
        }
    },
    watch: {
        'question.content' : {   
            handler(question) {
                // remount the component when the question content changes.  For some reason state wasn't working with tiptap so this 'refreshes' the component with the new data
                this.showComponent = false;
                this.$nextTick(() => {
                    this.showComponent = true;
                });
            }
        }
    },
    methods: {}
}
</script>
